<template>
    <ul class="staff_list_wrap">
        <Item
            v-for="(employee, index) in results" :key="index"
            :employee="employee"
            :focusedItem="focusedItem"
            @selectEmployee="selectEmployee"
        />
        <li class="no_search" v-if=noResult>"{{ keyword }}" 없음</li>
    </ul>
</template>


<script>
import Item from './CalendarSearchResultItem.vue'
import { workerState } from '../../../../../worker-state'

export default {
    components: { Item },
    props: {
        keyword: String,
        results: Array,
        focusedItem: Object,
    },
    data() {
        return {
            worker: workerState,
        }
    },
    computed: {
        noResult: function() { return (this.results?.length ?? 0) == 0 },
    },
    methods: {
        selectEmployee(employee) {
            this.$emit('selectEmployee', employee)
        }
    }
}
</script>